import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    hasPending: Boolean,
    processingText: String,
    countdownText: String,
    redisErrorText: String
  }

  static targets = ["alert", "message", "countdown"]

  connect() {
    if (this.hasPendingValue) {
      this.showAlert()
      this.checkStatus()
    }
  }

  disconnect() {
    this.stopPolling()
    this.stopCountdown()
  }

  startPolling() {
    this.stopPolling()
    this.pollInterval = setInterval(() => this.checkStatus(), 5000)
  }

  stopPolling() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval)
      this.pollInterval = null
    }
  }

  startCountdown(seconds) {
    this.stopCountdown()
    this.remainingSeconds = seconds

    this.updateCountdownDisplay()

    this.countdownInterval = setInterval(() => {
      this.remainingSeconds--

      if (this.remainingSeconds <= 0) {
        this.stopCountdown()
        this.showProcessing()
        // Start polling to detect when flush completes
        this.startPolling()
      } else {
        this.updateCountdownDisplay()
      }
    }, 1000)
  }

  stopCountdown() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
      this.countdownInterval = null
    }
  }

  updateCountdownDisplay() {
    if (this.hasCountdownTarget) {
      const text = this.countdownTextValue.replace('%{seconds}', this.remainingSeconds)
      this.countdownTarget.textContent = text
      this.countdownTarget.style.display = ''
    }
  }

  showProcessing() {
    if (this.hasCountdownTarget) {
      this.countdownTarget.style.display = 'none'
    }
    if (this.hasMessageTarget) {
      this.messageTarget.textContent = this.processingTextValue
    }
  }

  async checkStatus() {
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          'Accept': 'application/json'
        }
      })

      if (response.ok) {
        const data = await response.json()

        if (data.redis_error) {
          this.showRedisError()
          this.stopPolling()
          return
        }

        if (data.has_pending) {
          this.showAlert()

          if (data.remaining_seconds > 0) {
            this.stopPolling()
            this.startCountdown(data.remaining_seconds)
          } else {
            this.showProcessing()
          }
        } else {
          this.hideAlert()
          this.stopPolling()
          this.stopCountdown()
          // Reload page to show updated history
          window.location.reload()
        }
      }
    } catch (error) {
      console.error('Error checking pending status:', error)
    }
  }

  showRedisError() {
    if (this.hasMessageTarget) {
      this.messageTarget.textContent = this.redisErrorTextValue
    }
    if (this.hasCountdownTarget) {
      this.countdownTarget.style.display = 'none'
    }
    this.showAlert()
  }

  showAlert() {
    if (this.hasAlertTarget) {
      this.alertTarget.style.display = ''
    }
  }

  hideAlert() {
    if (this.hasAlertTarget) {
      this.alertTarget.style.display = 'none'
    }
  }
}
